/**
 * This file will configure various resources for your application.
 * - Logging to New Relic
 * - Analytics tracking through Adobe Target Events
 * - Daxi (The Origin Digital http request library)
 *
 * Anything else required before your app is loaded can be included in this
 * file.
 */

import {
  configAnalytics,
  configNewRelicLogger,
} from "@origin-digital/reporting-client";
import { configFetch, configFetchCache } from "@origin-digital/daxi";
import { appName, config } from "./config";

const envAppName = `${appName}-${config.env}`;

configAnalytics({
  appName,
  debugToConsole: config.analyticsDebugToConsole,
});

try {
  configNewRelicLogger({
    appName: envAppName,
    consoleLogLevel: config.logLevelConsole as LogLevel,
    logLevel: config.logLevelNewRelic as LogLevel,
    sendOnErrors: config.newRelicSendOnErrors,
    sourceEnv: config.env as EnvironmentNames,
  });
} catch (e) {
  // New Relic logger may fail in test environments without apiKey
  console.warn("Failed to configure New Relic logger:", e);
}

/* eslint-disable-next-line no-undef */
configFetch({
  host: config.apiBasePath,
  disableAuthCheck: __DEV__,
  environment: config.env,
});

configFetchCache({ disableCache: __DEV__ });

if (__DEV__) {
  require("./mocks/eventDispatcherMocks");
}
